module.exports = __webpack_public_path__ + "static/media/paso_a_paso.2ec7a51e.png";